import { render, staticRenderFns } from "./DmqModal.vue?vue&type=template&id=63564bda&"
import script from "./DmqModal.vue?vue&type=script&lang=ts&"
export * from "./DmqModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports